import { Api } from "../../api";

export const getFilter = (code) => {
  return async (dispatch, getState) => {
    const { section } = getState();
    const { filter } = getState();
    const response = await Api.server.getFilter({
      params: section.params,
      filter: filter.params,
    });
    dispatch({ type: "FETCH_FILTER", payload: response });
  };
};

export const setFilterParams = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_FILTER_PARAMS", payload: value });
  };
};
